import tw from 'tailwind-styled-components'

export const TwMessageIcon = tw.div<{
  $bgOrange?: boolean
  $bgWhite?: boolean
}>`
  w-40
  h-40
  rounded-full
  shrink-0
  flex
  items-center
  justify-center
  ${p => (p.$bgOrange ? 'bg-sticker-orange shadow-xs' : '')}
  ${p => (p.$bgWhite ? 'bg-primary shadow-xs' : '')}
`

export const TwMessageContainer = tw.div<{$position?: 'top' | 'center'}>`
  flex
  gap-12
  mt-12
  ${p => (p.$position === 'center' ? 'items-center' : 'items-start')}
`
